module.exports = __webpack_public_path__ + "static/hero-bg-bb3d3ab868416bac0b1d4ac0e89340cf.jpg";